import { useState } from 'react';
import { Button } from 'components/Elements';
import { useMessagingSocket } from 'providers/messaging';

export const MessageInput = ({ conversationId }) => {
  const [text, setText] = useState('');
  const { emitMessage, emitTypingStart, emitTypingStop, connected } = useMessagingSocket();

  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed || !conversationId) return;
    emitMessage({ conversationId, ciphertext: trimmed, type: 'text' });
    setText('');
    emitTypingStop(conversationId);
  };

  const handleTyping = (e) => {
    setText(e.target.value);
    emitTypingStart(conversationId);
    clearTimeout(window.typingTimeout);
    window.typingTimeout = setTimeout(() => emitTypingStop(conversationId), 2000);
  };

  // ✅ Handle Enter / Ctrl+Enter
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.ctrlKey || e.metaKey) {
        // allow new line
        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        setText((prev) => prev.slice(0, start) + '\n' + prev.slice(end));
        requestAnimationFrame(() => {
          e.target.selectionStart = e.target.selectionEnd = start + 1;
        });
      } else {
        e.preventDefault(); // prevent newline
        handleSend();
      }
    }
  };

  return (
    <div className="border-t border-gray-100 p-3 flex items-center gap-2">
      <textarea
        className="flex-1 border border-gray-200 rounded-md p-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400 resize-none"
        placeholder={connected ? 'Type your message...' : 'Socket not connected...'}
        value={text}
        onChange={handleTyping}
        onKeyDown={handleKeyDown}
        rows={2}
        disabled={!connected}
      />
      <Button onClick={handleSend} disabled={!connected}>
        Send
      </Button>
    </div>
  );
};
